// Dependencies
import radium from 'radium';
import Button from '../../../components/button/Button.tsx';

function BestSeatBookingBtn() {
	const style = {
		margin: '0 0 0.5em 0',
		'@media (min-width : 768px)': {
			padding: '1em 0 0.5em',
		},
	};

	function openBestSeatBooking() {
		window.location.href = `${window.location.href}/seatingplan`;
	}

	return (
		<div style={style}>
			<Button
				name="bestSeatBooking"
				buttonText="Bestplatzbuchung"
				btnStyle="highlight"
				onClick={openBestSeatBooking}
			/>
		</div>
	);
}

export default radium(BestSeatBookingBtn);
